import { render, staticRenderFns } from "./SendDetails.vue?vue&type=template&id=0b36501e&"
import script from "./SendDetails.vue?vue&type=script&lang=js&"
export * from "./SendDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports